import { render, staticRenderFns } from "./ModelGroupInfoModal.vue?vue&type=template&id=4fdb0fde"
import script from "./ModelGroupInfoModal.vue?vue&type=script&lang=js"
export * from "./ModelGroupInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports